/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor (hex, parent)
  {
    this.hex = hex;
    this.parent = parent;
  }


  getNeighbor (index)
  {
    const hex = this.hex.getNeighborsInOrder()[index];

    return this.parent.getZone(hex);
  }


  getNeighbors ()
  {
    return this.hex.getNeighborsInOrder().map(hex => this.parent.getZone(hex));
  }


  isExternalBorder (neighbor)
  {
    return neighbor == null;
  }


  isTemporaryBorder (neighbor)
  {
    return false;
  }


  isGroupBorder (neighbor)
  {
    return false;
  }


  isJaggedBorder (neighbor)
  {
    return false;
  }



  isEmphasized ()
  {
    return false;
  }


  isDimmed ()
  {
    return false;
  }


  getBeaconValue ()
  {
    return 0;
  }


  isEstablished ()
  {
    return false;
  }


  getBackgroundBand ()
  {
    return 1;
  }


  getDisplayHex ()
  {
    return this.hex;
  }


  getEntityHex ()
  {
    return this.hex;
  }


  getColor ()
  {
    return null;
  }


  equals (other)
  {
    return other?.constructor === this.constructor && this.hex.equals(other.hex) && this.parent.equals(other.parent);
  }


};
